export default __webpack_public_path__ + "static/media/header-bg.42bc6b2f.jpg";